import { useEffect } from 'react';
import { useBreadcrumbs } from '@components/shared/withBreadcrumbs';
import routes from '@root/routes';
import { Listing } from '@root/types';
import { useFlags } from 'launchdarkly-react-client-sdk';

const useListingPageBreadcrumbs = (
  listing: Listing | undefined,
  buildingBreadcrumbClicked: () => {},
  searchBreadcrumbClicked: () => {},
) => {
  const { setBreadcrumbs } = useBreadcrumbs();
  const flags = useFlags();

  useEffect(() => {
    if (!listing) return;

    const marketNameBreadcrumb = listing.marketName
      ? [
          {
            content: listing.marketName,
            link: flags['new-search-redirect']
              ? routes.search(listing.marketSlug!)
              : routes.listingSearchForMarket(listing.marketShapeSlug),
            onClick: () => {
              searchBreadcrumbClicked();
            },
          },
        ]
      : [];

    const buildingBreadcrumb = {
      content: listing.buildingName,
      link: routes.building(listing.buildingSlug),
      onClick: () => {
        buildingBreadcrumbClicked();
      },
    };

    setBreadcrumbs([...marketNameBreadcrumb, buildingBreadcrumb, listing.name]);
  }, [listing]);
};

export default useListingPageBreadcrumbs;
